import {useEffect, useMemo, useState} from "react";
import {
    getWatchFields,
    mapDataFieldsForFormFields, mapDataFieldsIntoSections, preProcessFormData, renderSections
} from "./AutoFormBase";

const useAutoForm = ({formName, rows}) =>
{
    const fieldsToWatch = useMemo(() => getWatchFields ( formName, rows ), [rows]);

    const sections = useMemo(() => mapDataFieldsIntoSections(rows, formName), [rows]);

    // Now we can generate the data from each row
    const formFields = useMemo(() => mapDataFieldsForFormFields ( rows ), [rows]);

    return { isReady: true, fieldsToWatch, formFields, sections, renderSections, preProcessFormData }
}

export default useAutoForm;